import React from "react";

function Checkbox({ id, label, checked = false, onChange = () => {} }) {
	return (
		<label htmlFor={id} className="p-0 text-gray-700 flex items-center flex-1">
			<input
				type="checkbox"
				className="sr-only checkmark-input"
				id={id}
				name={id}
				checked={checked}
				onChange={onChange}
			/>
			<span className="checkmark border-2 rounded border-primary h-4 w-4 mr-2"></span>
			{label}
		</label>
	);
}

export default Checkbox;
